import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { useAtom } from "jotai";
import {
	scannerRequestStateAtom,
	examRequestErrorStateAtom,
} from "../../../../components/Atoms/atoms";

function valuetext(value) {
	return `${value}°C`;
}

export default function RangeSlider(props) {
	const [state, setState] = useAtom(scannerRequestStateAtom);
	const [errorState, setErrorState] = useAtom(examRequestErrorStateAtom);
	const [value, setValue] = React.useState([Number(state.lqNum) || 1, Number(state.hqNum) || 100]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setState({ ...state, lqNum: newValue[0], hqNum: newValue[1] });
		setErrorState({
			...errorState,
			lqNum: newValue[0] > 0 ? false : true,
			hqNum: newValue[1] > 1 ? false : true,
		});
	};

	return (
		<Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 2 }}>
			<input
				type="number"
				name="lqNum"
				value={state.lqNum || ""}
				onChange={(e) => {
					setState({
						...state,
						lqNum: e.target.value ? Number(e.target.value) : "",
					});
					setValue([e.target.value ? Number(e.target.value) : 0, value[1]]);
				}}
				className={`border p-2 rounded w-20 mb-2 ${
					!state.lqNum ? "ring-2 ring-primaryGold animate-pulse" : ""
				}`}
			/>
			<Slider
				getAriaLabel={() => "Number of Questions in Exam"}
				value={value}
				color={state.lqNum && state.hqNum ? "primary" : "error"}
				onChange={handleChange}
				min={1}
				max={250}
				valueLabelDisplay="auto"
				getAriaValueText={valuetext}
			/>
			<input
				type="number"
				name="hqNum"
				value={state.hqNum || ""}
				onChange={(e) => {
					setState({
						...state,
						hqNum: e.target.value ? Number(e.target.value) : "",
					});
					setValue([value[0], e.target.value ? Number(e.target.value) : 0]);
				}}
				className={`border p-2 rounded w-20 mb-2 ${
					!state.hqNum ? "ring-2 ring-primaryGold animate-pulse" : ""
				}`}
			/>
		</Box>
	);
}
